import {
  call,
  put,
  select,
  take,
} from 'redux-saga/effects';

import { toast } from 'react-toastify';

import {
  apiGet,
} from '../../../common/utils/saga-utils';

import {
  ROBOT_LOAD_REQUEST,
  ROBOT_LOAD_ERROR,
  ROBOT_LOAD_ERROR_MESSAGE,
  setCurrentRobot,
  loadRobotSuccess,
  setSceneLoaded,
} from '../actions';

import {
  getCurrentRobot,
} from '../selectors';

import addPartToWorkspaceSaga from './addPartToWorkspaceSaga';
import initializeConfiguratorSaga from './initializeConfiguratorSaga';

export default function* loadRobotWatcher(threeProcessor) {
  while (true) {
    try {
      const { payload } = yield take([
        ROBOT_LOAD_REQUEST,
      ]);

      const { id } = payload;
      yield call(threeProcessor.clearScene);
      yield call(initializeConfiguratorSaga);
      yield put(setCurrentRobot(id));
      yield call(loadRobot, id);
      yield call(addRobotToWorkspace, threeProcessor);
      yield put(setSceneLoaded(true));
    } catch (error) {
      yield put({ type: ROBOT_LOAD_ERROR, error });
      yield call(toast.error, ROBOT_LOAD_ERROR_MESSAGE);
    }
  }
}

function* loadRobot(id) {
  const robot = yield call(apiGet, `/Robot/${id}`);
  yield put(loadRobotSuccess(robot));
}

function* addRobotToWorkspace(threeProcessor) {
  const currentRobot = yield select(getCurrentRobot);
  const robotParts = currentRobot.robotParts.toModelArray();

  for (const robotPart of robotParts) {
    yield call(addPartToWorkspaceSaga, robotPart.id, threeProcessor);
  }
}
